/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
// import { useMediaQuery } from 'react-responsive';
// import { Link } from 'react-scroll';
// import firebase from 'firebase/app';
// import Checkbox from '@material-ui/core/Checkbox';
// import axios from 'axios';
// import fb from 'firebaseConfig';
// import * as Sentry from '@sentry/react';
// import { BsCaretDownFill } from 'react-icons/bs';
// import { FaFacebookSquare } from 'react-icons/fa';
// import PlayVideoIcon from 'assets/icons/SvgIcons/PlayVideoIcon';

import { getEula } from 'services/api/eula';
// import { firebaseErrors } from 'services/api/firebaseErrors';

// import { Text } from 'components/Text';
import { Button } from 'components/Button';
import { ALERT_TYPE } from 'components/Alert';
// import { Input, TextArea } from 'components/Input';
import SnackMessage, { OPTIONS } from 'components/SnackMessage';

// import BREAKPOINT from 'assets/styles/breakpoints';
// import imgBackground from 'assets/images/phone-lp.png';

import Detail5 from 'assets/icons/detail-5.svg';
import Detail6 from 'assets/icons/detail-6.svg';
// import Detail7 from 'assets/icons/detail-7.svg';
// import logoForm from 'assets/icons/logo-form.svg';
// import GoogleIcon from 'assets/icons/SvgIcons/Google';
// import Facebook from 'assets/icons/logo-facebook.svg';
// import Linkedin from 'assets/icons/logo-linkedin.svg';
// import Instagram from 'assets/icons/logo-instagram.svg';
// import Twitter from 'assets/icons/logo-twitter.svg';
// import Deliverables from 'assets/icons/example-deliverables.svg';

// import { Divider } from 'pages/SignUp/styles';
import EulaModal from 'pages/SignUp/EulaModal';

// import PATH from 'routes/path';
import Menu from './Menu';
import VideoModal from './VideoModal';
import {
  Container,
  Footer, Box,
  Wrapper,
  Content,
} from './styles';
// import Depoiment from './Depoimento';

// const defaultUser = {
//   phone: '',
//   email: '',
//   name: '',
//   message: '',
// };
//
// const sendGridApiUrl = process.env.REACT_APP_API_EMAIL_URL;
// const sendGridKey = process.env.REACT_APP_SENDGRID_API_KEY;

// Landing Page
const Landing = () => {
  // const [user, setUser] = useState(defaultUser);
  const [eula, setEula] = useState({});
  const [openEula, setOpenEula] = useState(false);
  const [openVideo, setOpenVideo] = useState(false);
  const [isPrivacy] = useState(false);
  // const [checked, setChecked] = useState(false);
  // const [checkedNotifications, setCheckedNotifications] = useState(false);
  // const [loadingMsg, setLoadingMsg] = useState(false);
  // const mktInputRef = useRef(null);

  const { enqueueSnackbar } = useSnackbar();

  // Provedor de Autenticação (Google)
  // const googleProvider = new firebase.auth.GoogleAuthProvider();

  // Provedor de Autenticação (Facebook)
  // const facebookProvider = new firebase.auth.FacebookAuthProvider();

  // const isMobile = useMediaQuery({ query: `(max-width: ${BREAKPOINT.MD_2})` });

  // const showEula = () => setOpenEula(true);

  const closeEula = () => setOpenEula(false);

  // Carrega os Termos de Uso/Política de Privacidade
  const loadEula = async () => {
    try {
      const { data } = await getEula();
      setEula(data[0]);
    } catch (error) {
      enqueueSnackbar('Erro ao carregar os Termos de Uso e a Política de Privacidade.', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={ALERT_TYPE.ERROR}
          />
        ),
      });
    }
  };

  const currentYear = new Date().getFullYear();

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //
  //   setUser({
  //     ...user,
  //     [name]: value,
  //   });
  // };

  // const handleCheck = (e) => {
  //   setChecked(e.target.checked);
  // };

  // const handleWatchVideo = () => {
  //   setOpenVideo(true);
  //   fb.analytics().logEvent('vídeo institucional');
  // };

  const handleCloseVideo = () => setOpenVideo(false);

  // Login com a conta do Google
  // const handleSignWithGoogle = async () => {
  //   if (checked && checkedNotifications) {
  //     try {
  //       await fb.auth().signInWithPopup(googleProvider);
  //       /** @type {firebase.auth.OAuthCredential} */
  //
  //       localStorage.session = 'true';
  //       localStorage.events = JSON.stringify([
  //         '21 - acesso google',
  //         '50 - primeiro acesso',
  //       ]);
  //       localStorage.setItem('mkt_cookies', mktInputRef.current.value);
  //       localStorage.setItem('event', 'register/customer');
  //     } catch (error) {
  //       Sentry.captureException(new Error('failed to login with Google'));
  //       if (error.code) {
  //         enqueueSnackbar(firebaseErrors[error.code], {
  //           ...OPTIONS,
  //           content: (key, message) => (
  //             <SnackMessage
  //               id={key}
  //               message={message}
  //               variant={ALERT_TYPE.ERROR}
  //             />
  //           ),
  //         });
  //       }
  //     }
  //   } else if (checkedNotifications) {
  //     enqueueSnackbar(
  //       'Para prosseguir é necessário estar de acordo com a Política de Privacidade.',
  //       {
  //         ...OPTIONS,
  //         content: (key, message) => (
  //           <SnackMessage
  //             id={key}
  //             message={message}
  //             variant={ALERT_TYPE.ERROR}
  //           />
  //         ),
  //       },
  //     );
  //   } else if (checked) {
  //     enqueueSnackbar(
  //       'Para prosseguir é necessário aceitar o envio de notificações.',
  //       {
  //         ...OPTIONS,
  //         content: (key, message) => (
  //           <SnackMessage
  //             id={key}
  //             message={message}
  //             variant={ALERT_TYPE.ERROR}
  //           />
  //         ),
  //       },
  //     );
  //   } else {
  //     enqueueSnackbar(
  //       'Para prosseguir é necessário estar de acordo com a Política de Privacidade e com as notificações.',
  //       {
  //         ...OPTIONS,
  //         content: (key, message) => (
  //           <SnackMessage
  //             id={key}
  //             message={message}
  //             variant={ALERT_TYPE.ERROR}
  //           />
  //         ),
  //       },
  //     );
  //   }
  // };

  // Login com a conta do Facebook
  // const handleSignWithFacebook = async () => {
  //   if (checked && checkedNotifications) {
  //     try {
  //       await fb.auth().signInWithPopup(facebookProvider);
  //       /** @type {firebase.auth.OAuthCredential} */
  //
  //       localStorage.session = 'true';
  //       localStorage.events = JSON.stringify([
  //         '21 - acesso facebook',
  //         '50 - primeiro acesso',
  //       ]);
  //       localStorage.setItem('mkt_cookies', mktInputRef.current.value);
  //       localStorage.setItem('event', 'register/customer');
  //     } catch (error) {
  //       Sentry.captureException(new Error('failed to login with Facebook'));
  //       if (error.code) {
  //         enqueueSnackbar(firebaseErrors[error.code], {
  //           ...OPTIONS,
  //           content: (key, message) => (
  //             <SnackMessage
  //               id={key}
  //               message={message}
  //               variant={ALERT_TYPE.ERROR}
  //             />
  //           ),
  //         });
  //       }
  //     }
  //   } else if (checkedNotifications) {
  //     enqueueSnackbar(
  //       'Para prosseguir é necessário estar de acordo com a Política de Privacidade.',
  //       {
  //         ...OPTIONS,
  //         content: (key, message) => (
  //           <SnackMessage
  //             id={key}
  //             message={message}
  //             variant={ALERT_TYPE.ERROR}
  //           />
  //         ),
  //       },
  //     );
  //   } else if (checked) {
  //     enqueueSnackbar(
  //       'Para prosseguir é necessário aceitar o envio de notificações.',
  //       {
  //         ...OPTIONS,
  //         content: (key, message) => (
  //           <SnackMessage
  //             id={key}
  //             message={message}
  //             variant={ALERT_TYPE.ERROR}
  //           />
  //         ),
  //       },
  //     );
  //   } else {
  //     enqueueSnackbar(
  //       'Para prosseguir é necessário estar de acordo com a Política de Privacidade e com as notificações.',
  //       {
  //         ...OPTIONS,
  //         content: (key, message) => (
  //           <SnackMessage
  //             id={key}
  //             message={message}
  //             variant={ALERT_TYPE.ERROR}
  //           />
  //         ),
  //       },
  //     );
  //   }
  // };

  // Envio do form. de contato
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //
  //   setLoadingMsg(true);
  //
  //   const { name, email, message } = user;
  //
  //   const payload = {
  //     name,
  //     email,
  //     message,
  //     product: 'LOIT FGTS',
  //   };
  //
  //   await axios.post(
  //     sendGridApiUrl,
  //     payload,
  //     {
  //       headers: {
  //         'X-API-KEY': sendGridKey,
  //       },
  //     },
  //   ).then(() => {
  //     // Evento do Intercom
  //     window.Intercom('trackEvent', 'LOIT FGTS contato form');
  //
  //     setUser({
  //       ...user,
  //       name: '',
  //       email: '',
  //       message: '',
  //     });
  //     enqueueSnackbar('Mensagem enviada com sucesso!', {
  //       ...OPTIONS,
  //       content: (key, msg) => (
  //         <SnackMessage
  //           id={key}
  //           message={msg}
  //           variant={ALERT_TYPE.SUCCESS}
  //         />
  //       ),
  //     });
  //   }).catch(() => {
  //     enqueueSnackbar('Desculpe, ocorreu um erro ao enviar a mensagem!', {
  //       ...OPTIONS,
  //       content: (key, msg) => (
  //         <SnackMessage
  //           id={key}
  //           message={msg}
  //           variant={ALERT_TYPE.ERROR}
  //         />
  //       ),
  //     });
  //   }).finally(() => {
  //     setLoadingMsg(false);
  //   });
  // };

  // Init
  useEffect(() => {
    document.title = 'LOIT FGTS - Revisão monetária do seu FGTS';

    loadEula();
  }, []);

  return (
    <Wrapper>
      {/* Termos de Uso */}
      <EulaModal
        data={eula}
        open={openEula}
        onClose={closeEula}
        isPrivacy={isPrivacy}
      />
      {
        openVideo && (
          <VideoModal
            open={openVideo}
            onClose={handleCloseVideo}
          />
        )
      }
      {/* Menu */}
      <Menu />
      {/* Hero */}
      {/* <Hero> */}
      {/* <Container> */}
      {/*     <h1> */}
      {/*       Descubra o valor (R$) que você pode receber com a revisão do seu FGTS */}
      {/*     </h1> */}
      {/*     <h2>Sem custo e sem compromisso. */}
      {/*       <Link */}
      {/*         spy */}
      {/*         smooth */}
      {/*         to="info-loit" */}
      {/*         duration={1000} */}
      {/*         activeClass="active" */}
      {/*         offset={isMobile ? -70 : -88} */}
      {/*       > */}
      {/*         Saiba mais */}
      {/*         <BsCaretDownFill /> */}
      {/*       </Link> */}
      {/*     </h2> */}
      {/*     <h3> */}
      {/*       <Button */}
      {/*         variant="outlined" */}
      {/*         onClick={handleWatchVideo} */}
      {/*       > */}
      {/*         <PlayVideoIcon /> */}
      {/*         Assista ao vídeo */}
      {/*       </Button> */}
      {/*     </h3> */}
      {/*     <Card hero> */}
      {/*       <img */}
      {/*         src={logoForm} */}
      {/*         alt="Logo LOIT FGTS" */}
      {/*       /> */}
      {/*       <h4>Para iniciar, escolha uma das opções de cadastro:</h4> */}
      {/*       <form> */}
      {/*         { */}
      {/*           !localStorage.getItem('webview') && ( */}
      {/*             <> */}
      {/*               <Button */}
      {/*                 variant="outlined" */}
      {/*                 startIcon={<GoogleIcon />} */}
      {/*                 onClick={handleSignWithGoogle} */}
      {/*               > */}
      {/*                 Entre com o Google */}
      {/*               </Button> */}
      {/*               <Button */}
      {/*                 variant="outlined" */}
      {/*                 startIcon={<FaFacebookSquare color="#4267B2" />} */}
      {/*                 onClick={handleSignWithFacebook} */}
      {/*               > */}
      {/*                 Entre com o Facebook */}
      {/*               </Button> */}
      {/*               <Divider>ou</Divider> */}
      {/*             </> */}
      {/*           ) */}
      {/*         } */}
      {/*         <Button */}
      {/*           type="submit" */}
      {/*           href="cadastro" */}
      {/*         > */}
      {/*           {localStorage.getItem('webview') ? 'Entre com o seu número de celular' : 'Entre com o seu e-mail'} */}
      {/*         </Button> */}
      {/* Não exibir na webview (Android) */}
      {/* Termos de Uso */}
      {/*         <CheckBoxWrapper> */}
      {/*           <Checkbox */}
      {/*             id="eula" */}
      {/*             size="small" */}
      {/*             color="secondary" */}
      {/*             checked={checked} */}
      {/*             onChange={handleCheck} */}
      {/*             inputProps={{ 'aria-label': 'checkbox' }} */}
      {/*           /> */}
      {/*           <Text comment> */}
      {/*             Ao continuar você declara ter lido e estar de acordo com nossos */}
      {/*             {' '} */}
      {/*             <a */}
      {/*               target="_blank" */}
      {/*               href={PATH.EULA} */}
      {/*               rel="noreferrer" */}
      {/*             > */}
      {/*               Termos de Uso */}
      {/*             </a> */}
      {/*             {' '} */}
      {/*             e */}
      {/*             {' '} */}
      {/*             <a */}
      {/*               target="_blank" */}
      {/*               href="https://ajuda.tikal.tech/pt-BR/articles/5320633-declaracao-de-politica-de-privacidade-e-protecao-de-dados" */}
      {/*               rel="noreferrer" */}
      {/*             > */}
      {/*               Política de Privacidade. */}
      {/*             </a> */}
      {/*           </Text> */}
      {/*         </CheckBoxWrapper> */}
      {/*         <CheckBoxWrapper> */}
      {/*           <Checkbox */}
      {/*             size="small" */}
      {/*             color="secondary" */}
      {/*             checked={checkedNotifications} */}
      {/*             onChange={(e) => setCheckedNotifications(e.target.checked)} */}
      {/*             inputProps={{ 'aria-label': 'primary checkbox' }} */}
      {/*           /> */}
      {/*           <Text comment style={{ fontSize: 16 }}> */}
      {/*             Autorizo o envio de mensagens e notificações da LOIT */}
      {/*           </Text> */}
      {/*         </CheckBoxWrapper> */}
      {/*       </form> */}
      {/*     </Card> */}
      {/* Background image */}
      {/*     <img */}
      {/*       src={imgBackground} */}
      {/*       alt="App do usuário" */}
      {/*       className="img-background" */}
      {/*     /> */}
      {/*   </Container> */}
      {/* </Hero> */}
      {/* Info sobre o LOIT FGTS */}
      {/* <Content */}
      {/*   info */}
      {/*   id="info-loit" */}
      {/*   style={{ backgroundImage: `url(${Detail6})` }} */}
      {/* > */}
      {/*   <Container info> */}
      {/*     <Box style={{ backgroundImage: `url(${Detail5})` }}> */}
      {/*       <h3>Conheça a LOIT FGTS </h3> */}
      {/*       <p>A LOIT FGTS é uma ferramenta que foi criada para facilitar a sua busca pelo direito de corrigir os seus saldos do <abbr title="Fundo de Garantia do Tempo de Serviço">FGTS</abbr>! Oferecemos, gratuitamente, o valor do cálculo estimado a ser corrigido no seu saldo do FGTS, facilitando o acesso à Justiça e a busca pelo seu direito!</p> */}
      {/*       <p>Para isso, nós desenvolvemos um sistema automatizado que foi programado para ler os extratos do FGTS obtidos junto à Caixa Econômica Federal e apresentar o cálculo para você em poucos segundos.</p> */}
      {/*       <p>A partir do resultado, caso você tenha interesse em buscar a correção dos seus valores, é possível obter o nosso "Kit Correção FGTS”, que contém os Cálculos Revisionais e a Petição Inicial, que são os documentos necessários para solicitar a sua revisão no Juizado Especial Federal, juntos aos extratos do FGTS e os seus documentos pessoais.</p> */}
      {/*     </Box> */}
      {/*     <Box> */}
      {/*       <h3>Sobre a Revisão dos Saldos do FGTS</h3> */}
      {/*       <p>Se você trabalhou com carteira assinada em algum momento da vida, provavelmente tem uma ou mais contas de FGTS vinculadas ao seu nome (<abbr title="Cadastro de Pessoas Física">CPF</abbr> ou <abbr title="Programa de Integração Social">PIS</abbr>).</p> */}
      {/*       <p>Todos os meses os saldos dessas contas são corrigidos monetariamente pelo Índice da Caderneta de Poupança (TR).</p> */}
      {/*       <p>Desde 1999, a TR não tem acompanhado a inflação, trazendo perdas financeiras para os titulares das contas de FGTS.</p> */}
      {/*     </Box> */}
      {/*     <Box> */}
      {/*       <h3>Quem pode se beneficiar com a Revisão?</h3> */}
      {/*       <p>Todas as pessoas que mantiveram, durante o período de 1999 até hoje, algum contrato de trabalho em regime <abbr title="Consolidação das Leis do Trabalho">CLT</abbr>, contribuindo com o Fundo de Garantia por Tempo de Serviço (FGTS), podem pedir revisão pleiteando a diferença na justiça.</p> */}
      {/*       <p>Mesmo quem já efetuou o saque da conta pode solicitar a revisão dos saldos, pois, o direito está vinculado ao longo do período e você pode reaver as diferenças que foram perdidas.</p> */}
      {/*     </Box> */}
      {/**/}
      {/*   </Container> */}
      {/*   <Container> */}
      {/*     <Depoiment /> */}
      {/*   </Container> */}
      {/* </Content> */}
      <Content
        info
        id="info-loit"
        style={{ backgroundImage: `url(${Detail6})` }}
      >
        <Container info>
          <Box style={{ backgroundImage: `url(${Detail5})`, margin: '0 auto', width: '100%' }}>
            <h3>Informe: Revisão do FGTS foi julgada pelo STF em 12/06/2024</h3>
            <p>Depois de muita espera, finalmente o julgamento sobre o tema da Revisão do FGTS foi concluído no dia 12/06/2024 pelo STF.
            </p>
            <p>No momento, ainda é necessário aguardar publicação da ata com a decisão completa e também observar o entendimento desse resultado por parte dos advogados e juristas especialistas no assunto.
            </p>
            <p>Com isso nosso serviço de cálculos e documentação foi interrompido, visto que novos pedidos não podem ser protocolados neste momento.
            </p>
            <p>Por ora, podemos informar que foi definida uma nova regra de correção monetária com base na inflação, conforme solicitado na ADI 5090, porém foi negada a possibilidade de recuperação dos valores do passado.
            </p>
            <p>Neste contexto, devemos considerar que a mobilização pela Revisão do FGTS foi importante e bem sucedida pois resultou num aumento da correção dos saldos para todos os trabalhadores no futuro. Por outro lado a decisão decepciona o trabalhador que teve seu dinheiro desvalorizado no período de 1999 até hoje.
            </p>
            <p>Porém ainda é cedo para entender os desdobramentos da decisão, ainda poderá haver  recursos para buscar uma alteração nessa questão do retroativo mas, por ora, nenhuma ação é necessária ou mesmo possível.
            </p>
            <p>Seguiremos monitorando o tema e compartilhando as novidades quando tivermos as informações completas.
            </p>
            <p style={{ color: 'rgb(255, 91, 91)', fontWeight: 'bold' }}>LOIT, seu por direito.</p>
            <a href="https://tikaltech.typeform.com/to/rpSZ7INW">
              <Button style={{ background: 'rgb(255, 91, 91)' }}>
                Quero me manter informado
              </Button>
            </a>
          </Box>
        </Container>
      </Content>
      {/* FAQ */}
      {/* <Container className="wrapper"> */}
      {/*   <Faq style={{ backgroundImage: `url(${Detail7})` }}> */}
      {/*     <div> */}
      {/*       <h3>Dúvidas frequentes</h3> */}
      {/*       <ul> */}
      {/*         <li> */}
      {/*           <a */}
      {/*             target="_blank" */}
      {/*             rel="noreferrer" */}
      {/*             href="https://ajuda.tikal.tech/pt-BR/articles/4844402-quais-documentos-sao-necessarios-para-o-calculo" */}
      {/*           > */}
      {/*             Quais documentos são necessários? */}
      {/*           </a> */}
      {/*         </li> */}
      {/*         <li> */}
      {/*           <a */}
      {/*             target="_blank" */}
      {/*             rel="noreferrer" */}
      {/*             href="https://ajuda.tikal.tech/pt-BR/articles/4844117-como-posso-dar-entrada-no-processo" */}
      {/*           > */}
      {/*             Como posso dar entrada no processo? */}
      {/*           </a> */}
      {/*         </li> */}
      {/*         <li> */}
      {/*           <a */}
      {/*             target="_blank" */}
      {/*             rel="noreferrer" */}
      {/*             href="https://ajuda.tikal.tech/pt-BR/articles/4844488-qual-e-a-situacao-da-tese-no-tribunal" */}
      {/*           > */}
      {/*             Qual é a situação da Tese no Tribunal? */}
      {/*           </a> */}
      {/*         </li> */}
      {/*         <li> */}
      {/*           <a */}
      {/*             target="_blank" */}
      {/*             rel="noreferrer" */}
      {/*             href="https://ajuda.tikal.tech/pt-BR/articles/4844429-o-que-a-loit-fgts-oferece" */}
      {/*           > */}
      {/*             O que a LOIT FGTS oferece? */}
      {/*           </a> */}
      {/*         </li> */}
      {/*       </ul> */}
      {/*       <a */}
      {/*         target="_blank" */}
      {/*         rel="noreferrer" */}
      {/*         href="https://ajuda.tikal.tech/pt-BR/collections/2748191-loit-fgts" */}
      {/*       > */}
      {/* <Button>Consultar FAQ</Button> */}
      {/*       </a> */}
      {/*     </div> */}
      {/*   </Faq> */}
      {/*   <Contact> */}
      {/*     <h3>Entenda o Kit com a Petição e o Cálculo</h3> */}
      {/*     <SPCard> */}
      {/*       <p>A petição inicial contém seus dados pessoais e demonstra seu direito, com fundamentos jurídicos simples e diretos. A planilha de cálculo permite que você apresente para o Juiz uma estimativa do quanto seu FGTS perdeu valor de compra com o passar dos anos.</p> */}
      {/*       <img src={Deliverables} alt="Exemplo de entregáveis" /> */}
      {/*     </SPCard> */}
      {/*   </Contact> */}
      {/* </Container> */}
      {/* Contato */}
      {/* <Contact form> */}
      {/*   <h3>Entre em contato e tire as suas dúvidas</h3> */}
      {/*     <div> */}
      {/*   <Container className="wrapper"> */}
      {/*       <form onSubmit={handleSubmit}> */}
      {/* Nome */}
      {/*         <Input */}
      {/*           icon */}
      {/*           required */}
      {/*           name="name" */}
      {/*           value={user.name} */}
      {/*           onChange={handleChange} */}
      {/*           type="text" */}
      {/*           placeholder="Nome" */}
      {/*         /> */}
      {/* E-mail */}
      {/*         <Input */}
      {/*           icon */}
      {/*           required */}
      {/*           name="email" */}
      {/*           type="email" */}
      {/*           value={user.email} */}
      {/*           onChange={handleChange} */}
      {/*           placeholder="E-mail" */}
      {/*         /> */}
      {/* Mensagem */}
      {/*         <TextArea */}
      {/*           required */}
      {/*           name="message" */}
      {/*           value={user.message} */}
      {/*           onChange={handleChange} */}
      {/*           placeholder="Digite sua mensagem..." */}
      {/*         /> */}
      {/*         <input */}
      {/*           type="hidden" */}
      {/*           name="mkt_cookies" */}
      {/*           className="mkt_cookies" */}
      {/*           value="" */}
      {/*           ref={mktInputRef} */}
      {/*         /> */}
      {/*         <Button */}
      {/*           type="submit" */}
      {/*           loading={loadingMsg} */}
      {/*         > */}
      {/*           Enviar mensagem */}
      {/*         </Button> */}
      {/*       </form> */}
      {/*     </div> */}
      {/* Mídia Social */}
      {/*     <div> */}
      {/*       <h4>Estamos nas mídias</h4> */}
      {/*       <ul className="social"> */}
      {/*         <li> */}
      {/*           <a */}
      {/*             target="_blank" */}
      {/*             rel="noreferrer" */}
      {/*             href="https://www.facebook.com/tikaltech/" */}
      {/*           > */}
      {/*             <img src={Facebook} alt="Facebook" title="Facebook" /> */}
      {/*           </a> */}
      {/*         </li> */}
      {/*         <li> */}
      {/*           <a */}
      {/*             target="_blank" */}
      {/*             rel="noreferrer" */}
      {/*             href="https://www.linkedin.com/company/tikal-tech/" */}
      {/*           > */}
      {/*             <img src={Linkedin} alt="LinkedIn" title="LinkedIn" /> */}
      {/*           </a> */}
      {/*         </li> */}
      {/*         <li> */}
      {/*           <a */}
      {/*             target="_blank" */}
      {/*             rel="noreferrer" */}
      {/*             href="https://www.instagram.com/loit_legal/" */}
      {/*           > */}
      {/*             <img src={Instagram} alt="Instagram" title="Instagram" /> */}
      {/*           </a> */}
      {/*         </li> */}
      {/*       </ul> */}
      {/*       <ul> */}
      {/*         <li> */}
      {/*           <a href="mailto:atendimento@loitlegal.com.br"> */}
      {/*             atendimento@loitlegal.com.br */}
      {/*           </a> */}
      {/*         </li> */}
      {/*       </ul> */}
      {/*     </div> */}
      {/*   </Container> */}
      {/* </Contact> */}
      {/* Rodapé */}
      <Footer>
        {/* <h4>LOIT FGTS é um produto TIKAL TECH</h4> */}
        {/* <p>©  {currentYear} TIKAL TECH - Tia Tikal Inteligência Artificial LTDA - CNPJ: 22.125.577/0001-62</p> */}
        {/* <address>Av. Queiroz Filho, 1700 - São Paulo - SP, CEP 05319-000</address> */}
        <p>©  {currentYear} LOIT FGTS</p>
      </Footer>
    </Wrapper>
  );
};

export default Landing;
